var render = function render(_c,_vm){return _c('div',{staticClass:"my-4 lg:my-5 flex w-full"})
}
var staticRenderFns = []

export { render, staticRenderFns }